import {
  FETCH_STAFFS_FULFILLED,
  STAFFS_PENDING,
  STAFFS_REJECTED,
  ACTIVATE_STAFF_REJECTED,
  ACTIVATE_STAFF_FULFILLED,
  LOGIN_SUCCESS,
  CURRENT_STAFF_FULFILLED,
} from "../constants/staffs";

const initialState = {
  staffs: [],
  currentStaff: {},
  pending: false,
  error: {},
  loginSuccess: false,
};

export const staffs = (state = initialState, action) => {
  switch (action.type) {
    case STAFFS_PENDING:
      return {
        ...state,
        pending: true,
      };

    case STAFFS_REJECTED:
      const error = action.error.response.data.error;
      return {
        ...state,
        pending: false,
        currentStaff: {},
        error: {
          password: error.non_field_errors && error.non_field_errors[0],
        },
      };

    case FETCH_STAFFS_FULFILLED:
      const staffsKeys = Object.keys(action.response);
      let staffsArray = staffsKeys.map((el) => {
        return action.response[el];
      });
      return {
        ...state,
        pending: false,
        loginSuccess: false,
        staffs: [...staffsArray],
        error: {},
      };

    case ACTIVATE_STAFF_REJECTED:
      const error_staff = action.error.response.data;
      return {
        ...state,
        pending: false,
        error: {
          staff: error_staff.detail && error_staff.detail,
        },
      };

    case ACTIVATE_STAFF_FULFILLED:
      return {
        ...state,
        pending: false,
        loginSuccess: false,
      };

    case CURRENT_STAFF_FULFILLED:
      return {
        ...state,
        pending: false,
        currentStaff: action.response,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        loginSuccess: true,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/staffs.js